import BaseModel from './baseModel';

class CertPaymentModel extends BaseModel {
  // constructor(refs) {
  //   super(refs);
  //   this.Id;
  //   this.Title;
  //   this.Abstract;
  //   this.SelectedTags;
  //   this.Tags;
  //   this.Images;
  //   this.SelectedImages;
  // }
}

export default CertPaymentModel;